module.exports = __webpack_public_path__ + "img/4B5455_BBBFC4_97A0A6_838C90-256px.9a72badf.png";